import { render, staticRenderFns } from "./projectFinishDialog.vue?vue&type=template&id=5969676b&scoped=true"
import script from "./projectFinishDialog.vue?vue&type=script&lang=js"
export * from "./projectFinishDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5969676b",
  null
  
)

export default component.exports